import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface authStates {
  isLoggedIn: boolean;
  nickname: string | null;
  activeStep: number;
}

const initialState: authStates = {
  isLoggedIn: false,
  nickname: null,
  activeStep: 0,
};

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    loginSuccess: (state, action: PayloadAction<string>) => {
      state.isLoggedIn = true;
      state.nickname = action.payload;
    },
    logout: (state) => {
      state.isLoggedIn = false;
      state.nickname = null;
    },
    updateActiveStep: (state, action: PayloadAction<number>) => {
      state.activeStep = action.payload;
    }
  },
  extraReducers: (builder) => { },
})

export const {
  loginSuccess,
  logout,
  updateActiveStep,
} = authSlice.actions;
export default authSlice.reducer;
